import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { Select, Store } from '@ngxs/store';
import { RelatedToType } from '@shared/enums';
import { FieldDef } from 'app/core/models';
import { replaceSortField } from 'app/modules/reporting/reporting.functions';
import { DrillData } from 'app/modules/reporting/state/actions';
import { ReportingState } from 'app/modules/reporting/state/state';
import { GraphqlConnection, GraphqlConnectionMap, GraphqlResultPageInfo } from 'app/shared/models/graphql';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'app-drill-data',
  templateUrl: './drill-data.component.html',
  styleUrls: ['./drill-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrillDataVisualizationComponent {
  drillData$: Observable<{
    rows: any[];
    pageInfo?: GraphqlResultPageInfo;
  }> = this.store.select(ReportingState.getDrillData);

  private get connectionName(): string {
    if (this.data.relatedToType === RelatedToType.Property) {
      return GraphqlConnection.propertiesSqlBased;
    }

    return this.data.relatedToType;
  }

  private get keepConnectionCase(): boolean {
    return !!GraphqlConnectionMap[this.data.relatedToType];
  }

  constructor(
    private readonly store: Store,
    private readonly matDialogRef: MatDialogRef<DrillDataVisualizationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      relatedToType: string;
      category: string;
      series?: string;
      columns: string[];
      filters: { fjson: string };
      fields: FieldDef[];
      options: any;
    },
  ) {
    this.store.dispatch(
      new DrillData.Action({
        connection: this.connectionName,
        fields: this.data.columns,
        fieldDefs: this.data.fields,
        filter: this.data.filters,
        options: {
          keepConnectionCase: this.keepConnectionCase,
        },
      }),
    );
  }

  close(): void {
    this.matDialogRef.close();
  }

  onPageChanged(pageEvent: PageEvent): void {
    this.store.dispatch(
      new DrillData.Action({
        connection: this.connectionName,
        fields: this.data.columns,
        fieldDefs: this.data.fields,
        filter: {
          ...this.data.filters,
          pagination: {
            page: pageEvent.pageIndex + 1,
            size: pageEvent.pageSize,
          },
        },
        options: {
          keepConnectionCase: this.keepConnectionCase,
        },
      }),
    );
  }

  onSortChanged(sortEvent: Sort): void {
    const field = replaceSortField(sortEvent.active);
    const sort = sortEvent.direction === '' ? null : [{ field, order: sortEvent.direction }];

    this.store.dispatch(
      new DrillData.Action({
        connection: this.connectionName,
        fields: this.data.columns,
        fieldDefs: this.data.fields,
        filter: {
          ...this.data.filters,
          sort,
        },
        options: {
          keepConnectionCase: this.keepConnectionCase,
        },
      }),
    );
  }
}
